import { useCallback } from 'react';
import { callCenterApi } from './api';
import { Monitor } from './Monitor';
import { useCallCenter } from './store';
import { useLang } from '../../lib/language';

/**
 * The branch's own monitoring dashboard.
 *
 * Same component as the call centre's, pointed at `/branch/dashboard` — which
 * takes no branch parameter at all, so a counter tablet cannot be persuaded to
 * show another shop's numbers even by editing the request. The branch table is
 * hidden because there is only one branch in the answer, and a one-row table is
 * a worse way to say that than not drawing it.
 */
export function BranchMonitorScreen(): JSX.Element {
  const { t } = useLang();
  const bootstrap = useCallCenter((s) => s.bootstrap);

  const load = useCallback(
    (range: { from?: string; to?: string }) => callCenterApi.branch.dashboard(range),
    [],
  );

  if (!bootstrap?.provisioned || !bootstrap.settings.isEnabled) {
    return (
      <div className="cc-screen">
        <div className="cc-empty">
        <div className="cc-empty-title">
          {t({ en: 'Call Center monitor', ar: 'متابعة مركز الاتصال' })}
        </div>
        <p>
          {t({
            en: 'The Call Center is not switched on for this company.',
            ar: 'مركز الاتصال غير مفعّل لهذه الشركة.',
          })}
        </p>
        </div>
      </div>
    );
  }

  // Wrapped because this renders inside the till's `.workspace` — a two-column
  // grid with a 500px cart slot and no padding of its own. Without the wrapper
  // the monitor is squeezed into the left column with its controls flush
  // against the edges. See the `.cc-screen` rules.
  return (
    <div className="cc-screen">
      <Monitor load={load} showBranches={false} />
    </div>
  );
}
